import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Subject } from "rxjs";

@Component({
  selector: "app-popup-preview-image",
  templateUrl: "./popup-preview-image.component.html",
  styleUrls: ["./popup-preview-image.component.scss"],
})
export class PopupPreviewImageComponent implements OnInit, OnDestroy{
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PopupPreviewImageComponent>
  ) {}

  ngOnInit(): void {}

  public closePopup() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
